module.exports = __webpack_public_path__ + "static/media/StJohnsPreparatorySchool.b4ef1a69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/logos/StJohnsPreparatorySchool.png
// module id = 675
// module chunks = 0